export default __webpack_public_path__ + "static/media/compliance.075945ab.PNG";